import React from 'react';
import ShapeAnimation from '../../../ShapeAnimation';
const MobileBanner = () => {
  return (
    <>
      <div className="mobile-development-banner">
        <div className="d-table">
          <div className="d-table-cell">
            <div className="container">
              {/* <h1 class="banner-heading">Mobile App Development Company in Noida, India</h1> */}
            </div>
          </div>
        </div>
        <ShapeAnimation/>
      </div>
    </>
  )
}

export default MobileBanner